import { useDispatch } from "react-redux";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiThatThrows } from "containers/Request";

export const useDeleteVariantVersionDraft = (
  id?: string,
  variantId?: string
) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () =>
      dispatch(
        apiThatThrows.deleteTiVoVariantVersionDraft.action({
          params: { id, variantId },
        })
      ),
    onSuccess: () =>
      Promise.all([
        queryClient.invalidateQueries({ queryKey: ["providers"] }),
        queryClient.invalidateQueries({
          queryKey: ["variantVersionDraft", id, variantId],
        }),
      ]),
  });
};
